var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9838L6.13115 7.82222L9.86885 16H0V15.9838ZM6.36066 7.54747L9.44262 3.4101L11.0164 16L6.36066 7.54747ZM11.9672 0L14.3115 3.10303L11.9672 16L9.63935 3.10303L11.9672 0ZM12.9836 16L14.5082 3.39394L17.623 7.53131L12.9836 16ZM14.1475 16L17.8361 7.80606L24 16H14.1475Z",
    fill: "#88BB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegions);
export default __webpack_public_path__ + "static/media/REGIONS.6a8b4c1fee4458dff58ac42be46c5aa3.svg";
export { ForwardRef as ReactComponent };